import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// Logical area: FormInputView General Strings
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.webmodule-common.other.ui.templateresult.FormInputView.';

  public static readonly supportedFileTypes = `${Id.prefix}supportedFileTypes`;
  public static readonly first = `${Id.prefix}first`;
  public static readonly prev = `${Id.prefix}prev`;
  public static readonly next = `${Id.prefix}next`;
  public static readonly last = `${Id.prefix}last`;
  public static readonly uploadedFileThumbnailAlt = `${Id.prefix}uploadedFileThumbnailAlt`;
  public static readonly customRequestThumbnailAlt = `${Id.prefix}customRequestThumbnailAlt`;
  public static readonly thumbnailLabel = `${Id.prefix}thumbnailLabel`;
}

export class LangFormInputView {
  private constructor() {}

  public static supportedFileTypes(acceptedFiles: string): string {
    return interpolate(Id.supportedFileTypes, { acceptedFiles });
  }

  public static first(): string {
    return interpolate(Id.first);
  }

  public static prev(): string {
    return interpolate(Id.prev);
  }

  public static next(): string {
    return interpolate(Id.next);
  }

  public static last(): string {
    return interpolate(Id.last);
  }

  public static uploadedFileThumbnailAlt(): string {
    return interpolate(Id.uploadedFileThumbnailAlt);
  }

  public static customRequestThumbnailAlt(): string {
    return interpolate(Id.customRequestThumbnailAlt);
  }

  public static thumbnailLabel(): string {
    return interpolate(Id.thumbnailLabel);
  }
}

export class FormInputViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(
      Id.supportedFileTypes,
      'Currently supported file types are {{acceptedFiles}}',
      'Supported file types message'
    );
    register.add(Id.first, 'First', 'Paginator: first page');
    register.add(Id.prev, 'Prev', 'Paginator: previous page');
    register.add(Id.next, 'Next', 'Paginator: next page');
    register.add(Id.last, 'Last', 'Paginator: last page');
    register.add(
      Id.uploadedFileThumbnailAlt,
      'Thumbnail for the uploaded file',
      'Alt text for uploaded file thumbnail'
    );
    register.add(Id.customRequestThumbnailAlt, 'Custom Request Thumbnail', 'Alt text for custom request thumbnail');
    register.add(Id.thumbnailLabel, 'Thumbnail', 'Label for thumbnail image');
  }
}
